"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatsigAutoCapturePlugin = exports.runStatsigAutoCapture = exports.AutoCapture = exports.AutoCaptureEventName = void 0;
const client_core_1 = require("@statsig/client-core");
const AutoCapture_1 = require("./AutoCapture");
Object.defineProperty(exports, "AutoCapture", { enumerable: true, get: function () { return AutoCapture_1.AutoCapture; } });
Object.defineProperty(exports, "StatsigAutoCapturePlugin", { enumerable: true, get: function () { return AutoCapture_1.StatsigAutoCapturePlugin; } });
Object.defineProperty(exports, "runStatsigAutoCapture", { enumerable: true, get: function () { return AutoCapture_1.runStatsigAutoCapture; } });
var AutoCaptureEvent_1 = require("./AutoCaptureEvent");
Object.defineProperty(exports, "AutoCaptureEventName", { enumerable: true, get: function () { return AutoCaptureEvent_1.AutoCaptureEventName; } });
const __STATSIG__ = Object.assign((0, client_core_1._getStatsigGlobal)(), {
    AutoCapture: AutoCapture_1.AutoCapture,
    runStatsigAutoCapture: AutoCapture_1.runStatsigAutoCapture,
    StatsigAutoCapturePlugin: AutoCapture_1.StatsigAutoCapturePlugin,
});
exports.default = __STATSIG__;
